import { jwtDecode } from 'jwt-decode';
import storage from 'src/utils/storageUtils';

export const getUserFromToken = () => {
  const token = storage.get('TOKEN') || localStorage.getItem('token') || localStorage.getItem('TOKEN');
  if (!token) return null;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken?.user || decodedToken?.staff || decodedToken?.id;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const getStaffFromToken = () => {
  const token = storage.get('TOKEN') || localStorage.getItem('token') || localStorage.getItem('TOKEN');
  if (!token) return null;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken?.staff || decodedToken?.user || null;
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

